<template>
    <section>
        <div class="titleIn" id="ensure">
            <span class="titleIn-em-in">
                <em></em>服务保障</span>
        </div>
        <div class="servicewrap clearfix">
            <ul>
                <li class="clearfix">
                    <div class="serve-border">
                        <div class="clearfix serve-icon-warp">
                            <span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi1"></em>
                            </span>
                            <em class="fl serve-icon-arr"></em>
                        </div>
                        <div class="serve-txt">
                            <p class="serve-txt-tit">品牌齐全</p>
                            <p class="serve-txt-gary">涵盖了自主、合资、</p>
                            <p class="serve-txt-gary">进口等众多热销品牌</p>
                        </div>
                    </div>
                </li>
                <li class="clearfix">
                    <div class="serve-border">
                        <div class="clearfix serve-icon-warp">
                            <span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi2"></em>
                            </span>
                            <em class="fl serve-icon-arr"></em>
                        </div>
                        <div class="serve-txt">
                            <p class="serve-txt-tit">车型丰富</p>
                            <p class="serve-txt-gary">百款车型任您选择</p>
                            <p class="serve-txt-gary">看车选车比价一站式完成</p>
                        </div>
                    </div>
                </li>
                <li class="clearfix">
                    <div class="serve-border">
                        <div class="clearfix serve-icon-warp">
                            <span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi3"></em>
                            </span>
                            <em class="fl serve-icon-arr"></em>
                        </div>
                        <div class="serve-txt">
                            <p class="serve-txt-tit">低价优惠</p>
                            <p class="serve-txt-gary">车款价格层层对比</p>
                            <p class="serve-txt-gary">团车为您提供市场低价</p>
                        </div>
                    </div>
                </li>
                <li class="clearfix">
                    <div class="serve-border">
                        <div class="clearfix serve-icon-warp">
                            <span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi4"></em>
                            </span>
                            <em class="fl serve-icon-arr"></em>
                        </div>
                        <div class="serve-txt">
                            <p class="serve-txt-tit">车源保证</p>
                            <p class="serve-txt-gary">优质4s店供车</p>
                            <p class="serve-txt-gary">保证您现场买到优质车源</p>
                        </div>
                    </div>
                </li>
                <li class="clearfix">
                    <div class="serve-border">
                        <div class="clearfix serve-icon-warp">
                            <span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi5"></em>
                            </span>
                            <em class="fl serve-icon-arr"></em>
                        </div>
                        <div class="serve-txt">
                            <p class="serve-txt-tit">服务保证</p>
                            <p class="serve-txt-gary">专属销售
                                <span>免费</span>服务</p>
                            <p class="serve-txt-gary">力保您省时省力更省心</p>
                        </div>
                    </div>
                </li>
                <li class="clearfix">
                    <div class="serve-border">
                        <div class="clearfix serve-icon-warp">
                            <span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi6"></em>
                            </span>
                            <em class="fl serve-icon-arr"></em>
                        </div>
                        <div class="serve-txt">
                            <p class="serve-txt-tit">售后保障</p>
                            <p class="serve-txt-gary">现场车源全国联保</p>
                            <p class="serve-txt-gary">出现问题团车协助解决</p>
                        </div>
                    </div>
                </li>
                
                
            </ul>
        </div>
    </section>
</template>
<style scoped lang="less">
@import "../../../assets/less/common.less";
.servicewrap {
    background-color: #fff;
    padding: 0.266667rem;
    .serve-border {
        border: 1px solid #ff3938;
    }
    li {
        float: left;
        position: relative;
        width: 48%;
        margin: 0.106667rem 1%;
        overflow: hidden;
        .serve-icon-warp {
            position: absolute;
            left: 0;
            top: 0;
        }
        .serve-icon {
            position: relative;
            height: 2.0rem;
            width: 1.2rem;
            display: inline-block;
            background: #ff3938;
        }
        .serve-icon-zi {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -0.4rem;
            margin-left: -0.3rem;
            display: inline-block;
            width: 0.8rem;
            height: 0.8rem;
            background: url(../../../assets/img/common/serve-icon.png) no-repeat;
            background-size: 600% 100%;
        }
        .serve-icon-zi2 {
            background: url(../../../assets/img/common/serve-icon.png) no-repeat;
            background-size: 600% 100%;
            background-position: 20% 0;
        }
        .serve-icon-zi3 {
            background: url(../../../assets/img/common/serve-icon.png) no-repeat;
            background-size: 600% 100%;
            background-position: 40% 0;
        }
        .serve-icon-zi4 {
            background: url(../../../assets/img/common/serve-icon.png) no-repeat;
            background-size: 600% 100%;
            background-position: 60% 0;
        }
        .serve-icon-zi5 {
            background: url(../../../assets/img/common/serve-icon.png) no-repeat;
            background-size: 600% 100%;
            background-position: 100% 0;
        }
        .serve-icon-zi6 {
            background: url(../../../assets/img/common/serve-icon.png) no-repeat;
            background-size: 600% 100%;
            background-position: 80% 0;
        }
        .serve-icon-arr {
            display: inline-block;
            width: 0.2rem;
            height: 2.0rem;
            background: url(../../../assets/img/common/serve-icon.png) no-repeat;
            background-size: 100% 100%;
            margin-left: -0.013333rem;
        }
        .serve-txt {
            padding-top: 0.3rem;
            height: 1.7rem;
            overflow: hidden;
            text-align: center;
            p {
                padding-left: 1.3rem;
                line-height: 1.2em;
            }
        }
        .serve-txt-tit {
            .px2px(font-size, 28px);
        }
        .serve-txt-gary {
            color: #a8a8a8;
            .px2px(font-size, 24px);
        }
        @media screen and (max-width:641px) {
            .serve-txt {
                width: 120%;
                padding-top: 0.3rem;
                height: 1.7rem;
            }
            .serve-txt p {
                padding-left: 0.4rem;
                -moz-transform: scale(0.75, 0.75);
                -webkit-transform: scale(0.75, 0.75);
                -o-transform: scale(0.75, 0.75);
            }
        }
        @media screen and (min-width:641px) and (max-width:751px) {
            .serve-txt {
                width: 120%;
                padding-top: 0.4rem;
            }
            .serve-txt p {
                padding-left: 0.4rem;
                -moz-transform: scale(0.9, 0.9);
                -webkit-transform: scale(0.9, 0.9);
                -o-transform: scale(0.9, 0.9);
            }
        }
        @media screen and (min-width:751px) {
            .serve-txt {
                width: 102%;
                padding-top: 0.3rem;
            }
            .serve-txt p {
                -moz-transform: scale(0.95, 0.95);
                -webkit-transform: scale(0.95, 0.95);
                -o-transform: scale(0.95, 0.95);
                line-height: 1.4em;
            }
        }
    }
}
	
</style>
<script>
export default {
    name: 'promiseComponent',
    data:function() {
        return {
        }
    },
    mounted:function(){
    }
}
</script>



// WEBPACK FOOTER //
// src/components/global/promiseNew/promiseNew.vue